import React, { Component } from "react";
import { Icon as LegacyIcon } from "@ant-design/compatible";
import { UserOutlined } from "@ant-design/icons";
import { Layout, Tabs, message, Menu, Dropdown, Avatar, Button } from "antd";
import { connect } from "react-redux";
import { setLocaleConfig } from "@/state/action/comAction";
import { injectIntl } from "react-intl"; // 国际化切换语言
import "../../assets/stylus/com/layout/layout.styl"; // layout布局自定义样式
import PropTypes from "prop-types"; // 导入自定义的logo
import _ from "lodash";
import logo from "../../assets/img/starLogo.png";
// import chrome from "../../assets/img/chrome.png";
//获取登录后存储本地的菜单列表
import StarMenu from "../display/menu/menu";
// 导入配置的Tab组
import TabFrame from "../../tabs/tabs";
import { updatePanelsInfo } from "../../state/action/comAction";
// 微前端
import { MicroApp } from "../../microApp";
import ScLayoutMicroAppContainer from "./scLayoutMicroAppContainer";

// 定义组件对应的子组件
const { Header, Content, Sider } = Layout;
// const { Header, Content, Footer, Sider } = Layout;
const TabPane = Tabs.TabPane;

/*
 * layout(Tab) 框架布局
 * @class ScLayout
 * @constructor
 * @property {Array} panes 内容区域标签页数组
 * @property {Object} state 组件类的状态
 *
 * */

@connect((state) => state, { setLocaleConfig })
class ScLayout extends Component {
  // 获取父组件路由传递的属性
  static contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    const panes = []; //已打开的tab列表
    window.LayoutTab = this;
    this.internationalization = this.props.intl.messages.scLayoutTab;
    let language = null;
    if (this.props.intl.locale === "zh") {
      language = `${this.internationalization.lan1}(中文)`;
    } else if (this.props.intl.locale === "en") {
      language = `${this.internationalization.lan2}(English)`;
    } else if (this.props.intl.locale === "es") {
      language = `${this.internationalization.lan3}(Español)`;
    }
    this.state = {
      activeKey: null, // 当前显示的tab标签
      isFullScreen: false,
      panes, // 内容区域中存在的标签数组
      language: language, // 国际化文字
      layoutPaddingLeft: 186, // 内容左侧样式
      collapsed: false, // 左侧栏是否收缩
      clearOpenKey: false, // 清空 clearOpenKey
    };

    // 获取所有 key - Tab 对应信息
    this.Frame = new TabFrame(this.addTab.bind(this), this.remove.bind(this));
    this.internationalization = null;
    // 载入
    const microApp = new MicroApp(this.Frame);
    this.microApp = microApp;
  }

  components = {};

  componentWillMount() {
    this.initStore();
  }

  componentDidMount() {
    // this.resizeAutoHeight();
    // this.initStore();
    // this.watchFullScreen()
  }

  // 监听状态数据变化
  componentWillReceiveProps(nextProps) {
    let panelsInfo = null;
    if (panelsInfo) {
      return;
    }
    // console.log('componentWillReceiveProps:',nextProps.panelsInfo);
    panelsInfo = nextProps.panelsInfo;

    if (!_.isEqual(this.props.panelsInfo, nextProps.panelsInfo)) {
      this.setState({
        panes: panelsInfo.openPanels,
        activeKey: panelsInfo.activeKey,
      });
      this.setAppNameAndActiveKey(panelsInfo.activeKey, panelsInfo.openPanels);
      // 向子应用传递状态
      // this.microApp.setGlobalState({
      //   panes: panelsInfo.openPanels,
      //   activeKey: panelsInfo.activeKey,
      // });
    }
  }

  // 微前端 缓存子应用名称并向子应用通信
  setAppNameAndActiveKey = (activeKey, currentPanes) => {
    const activePanel = currentPanes.find((pane) => pane.key === activeKey);
    if (activePanel && typeof activePanel.content === "object" && activePanel.content.isMicroApp) {
      this.setState({
        currMicroAppName: activePanel.content.name,
      });
    } else {
      this.setState({
        currMicroAppName: null,
      });
    }
    // debugger
    // 删除contentRef不然在子应用json.stringify会报错循环引用
    const currentPanesNoCurrentRef = currentPanes.map((item) => {
      delete item.contentRef;
      return item;
    });
    this.microApp.setGlobalState({
      currentApp: this.state.currMicroAppName,
      activeKey,
      panes: currentPanesNoCurrentRef,
    });
  };

  // 添加tab页面
  addTab = (e, param) => {
    console.log('addTab','e:',e,'param:',param);
    let canAdd = !0;
    const panes = this.state.panes;
    const contentKey = `${e.key}`;
    const activeKey = param && param.keyId ? `${e.key}${param.keyId}` : `${e.key}`;
    // 设置最大显示窗口数量
    if (panes.length > 8) {
      message.warn(this.internationalization.msg1, 1);
      return;
    }
    for (const p of panes) {
      if (p.key === activeKey) {
        canAdd = !1;
      }
    }
    const addFrame = this.Frame[contentKey];

    if (canAdd) {
      window.LayoutTab["tabParam"] = param || "";
      panes.push({
        title: e.domEvent && e.domEvent.target ? e.domEvent.target.textContent : e.titleText,
        content: this.Frame[contentKey],
        key: activeKey,
        contentRef: this.refs.pageContent,
        param,
        closable: true,
      });
      this.setState({ panes, activeKey });
      this.context.store.dispatch(updatePanelsInfo(panes, activeKey));
      // 微前端 - 加载微前端模块
      const currMicroAppName =
        typeof addFrame === "object" && addFrame.isMicroApp ? addFrame.name : null;
      this.setState({
        currMicroAppName,
      });
     
      if (currMicroAppName) {
        // fix 首次加载子应用setGlobalState如果没有正确透传,可以在加载时直接设置Frame的initSetting;
        addFrame.initSetting = param ? param.initSetting : null;
        this.setState({
          appLoading: true,
        });
        const microApp = this.microApp.loadApp(activeKey, {
          addTab: this.addTab,
          removeTab: this.remove,
        });
        
        if (microApp) {
          microApp.mountPromise.then(() => {
            this.setState({
              appLoading: false,
            });
            this.microApp.setGlobalState({
              currentApp: currMicroAppName,
              activeKey: activeKey,
            });
          });
        } else {
          this.setState({
            appLoading: false,
          });
        }
      }
    } else {
      window.LayoutTab["tabParam"] = param || "";
      if (addFrame.isMicroApp) {
        const matchIndex = _.findIndex(panes, (cp) => {
          return cp.key === activeKey;
        });
        panes[matchIndex].param = param;
        this.onChange(activeKey);
        this.setState({ panes: [...panes], activeKey });
        this.context.store.dispatch(updatePanelsInfo(panes, activeKey));
        return;
      }
      const closeEnable = activeKey !== "010101";
      const removeIndex = _.findIndex(panes, (cp) => {
        return cp.key === activeKey;
      });
      panes.splice(removeIndex, 1);
      const replaceTitle =
        e.domEvent && e.domEvent.target ? e.domEvent.target.textContent : e.titleText;
      this.setState({ panes, activeKey }, () => {
        panes.splice(removeIndex, 0, {
          title: replaceTitle,
          content: this.Frame[contentKey],
          key: activeKey,
          contentRef: this.refs.pageContent,
          closable: closeEnable,
          param,
        });
        this.setState({ panes: [...panes], activeKey });
        this.context.store.dispatch(updatePanelsInfo(panes, activeKey));
      });
    }
    // console.log('addTab', 'activeKey:',activeKey,'panes:',panes);
  };

  // 重置自适应内容高度
  resizeAutoHeight() {
    const minH = window.innerHeight - 178;
    document.querySelector(".sc-content-auto").style.minHeight = `${minH}px`;
  }

  // 初始化并监听状态数据变化
  initStore() {
    const store = this.context.store;
    let panelsInfo = null;
    store.subscribe(() => {
      if (panelsInfo) {
        return;
      }
      panelsInfo = store.getState().panelsInfo;
      this.setState({
        panes: panelsInfo.openPanels,
        activeKey: panelsInfo.activeKey,
      });
    });
  }

  exit() {
    if (window.sessionStorage.getItem("token")) {
      window.sessionStorage.removeItem("token");
      window.sessionStorage.removeItem("userAccount");
      window.sessionStorage.removeItem("role");
    }
    if (window.sessionStorage.getItem("name")) {
      window.sessionStorage.removeItem("name");
      window.sessionStorage.removeItem("omc-token");
      window.sessionStorage.removeItem("omc-username");
      window.sessionStorage.removeItem("omc-userId");
      window.sessionStorage.removeItem("userId");
    }
    window.sessionStorage.removeItem("sso_code");
    window.sessionStorage.removeItem("companyId");
    this.context.router.history.push("login");
    window.location.reload();
  }

  editPassword() {
    this.addTab({
      key: "20210706password",
      titleText: "修改密码",
    });
  }

  // tab 回调事件设置
  onEdit = (targetKey, action) => {
    this[action](targetKey);
  };

  // 关闭其他按钮
  removeOther = () => {
    const activeKey = this.state.activeKey;

    const panes = this.state.panes.filter((pane) => pane.key === activeKey || pane.key === "02"); // 02工作台

    this.setState({ panes, activeKey });
    // this.props.updatePanelsInfo(panes, activeKey);
    this.context.store.dispatch(updatePanelsInfo(panes, activeKey));
  };

  //切换tab页面
  onChange = (activeKey) => {
    if (window.LayoutTab) {
      window.LayoutTab.tabId = "";
    }
    const currentPanels = this.context.store.getState().panelsInfo.openPanels;
    const panes = this.state.panes;
    this.setState({
      activeKey,
    });
    this.context.store.dispatch(updatePanelsInfo(panes, activeKey));
    const activePanel = _.find(currentPanels, (cp) => {
      return cp.key === activeKey;
    });
    if (activePanel) {
      window.LayoutTab["tabParam"] = activePanel.param || "";
    }
    this.context.store.dispatch(updatePanelsInfo(panes, activeKey));
  };

  //移除tab页面
  remove = (targetKey) => {
    let activeKey = this.state.activeKey;
    let lastIndex;
    this.state.panes.forEach((pane, i) => {
      if (pane.key === targetKey) {
        if (i === 0 && this.state.panes.length > 1) {
          lastIndex = 0;
        } else {
          lastIndex = i - 1;
        }
      }
    });
    const panes = this.state.panes.filter((pane) => pane.key !== targetKey);
    if (lastIndex >= 0 && activeKey === targetKey) {
      activeKey = panes[lastIndex].key;
    }
    this.setState({
      panes,
      activeKey,
    });
    this.context.store.dispatch(updatePanelsInfo(panes, activeKey));
  };

  // 国际化-切换语言
  changeLocale = (lang) => {
    if (lang === "zh") {
      this.setState({
        language: `${this.internationalization.lan1}(中文)`,
      });
      // this.props.setLocaleConfig('zh');
      window.sessionStorage.setItem("locale", "zh");
    } else if (lang === "en") {
      this.setState({
        language: `${this.internationalization.lan2}(English)`,
      });
      // this.props.setLocaleConfig('en');
      window.sessionStorage.setItem("locale", "en");
    } else if (lang === "es") {
      this.setState({
        language: `${this.internationalization.lan1}(Español)`,
      });
      // this.props.setLocaleConfig('es');
      window.sessionStorage.setItem("locale", "es");
    }

    // this.forceUpdate()

    // eslint-disable-next-line no-restricted-globals
    location.reload(false);
  };

  render() {
    // const childProps = {
    //   addTab: this.addTab,
    //   onEdit: this.onEdit,
    //   removeTab: this.remove,
    //   analysysAgent: this.analysysAgent,
    // };
    // 国际化语言版本
    this.internationalization = this.props.intl.messages.scLayoutTab;
    // console.log(this.internationalization);
    const menu = (
      <Menu>
        <Menu.Item>
          <a href="javascript:void(0);" onClick={this.exit.bind(this)}>
            {this.internationalization.btn1}
          </a>
        </Menu.Item>
        <Menu.Item>
          <a href="javascript:void(0);" onClick={this.editPassword.bind(this)}>
            修改密码
          </a>
        </Menu.Item>
      </Menu>
    );
    return (
      <Layout theme="light">
        <Sider
          style={{ height: "100vh" }}
          width="224"
          theme="dark"
          collapsed={false}
          collapsible={false}>
          <div className="logo">
            <img alt="" src={logo} />
          </div>
          <StarMenu
            theme="dark"
            clearOpenKey={this.state.clearOpenKey}
            collapsed={false}
            addTab={this.addTab}
            Frame={this.Frame}
          />
        </Sider>

        <Layout className="sc-oms-pagearea">
          <Header className="sc-oms-header" theme="light">
            <Dropdown overlay={menu}>
              <a className="ant-dropdown-link" href="javascript:void(0);">
                <Avatar
                  icon={<UserOutlined />}
                  size="small"
                  shape="square"
                  style={{ backgroundColor: "#5584FF", borderRadius: "24px" }}
                />
                <span className="username" style={{ color: "#000000" }}>
                  {window.sessionStorage.getItem("name")}
                </span>
                <LegacyIcon type="down" style={{ color: "#000000" }}></LegacyIcon>
              </a>
            </Dropdown>
          </Header>
          {/* style={{paddingLeft:this.state.collapsed?'100px':'206px'}} */}
          <Content ref="pageContent">
            <div className="sc-content-auto">
              <Button
                onClick={this.removeOther}
                style={{
                  position: "absolute",
                  right: "40px",
                  zIndex: "1000",
                  fontSize: "12px",
                  background: "#ffffff",
                  borderRadius: "4px",
                  border: "1px solid #D9D9D9",
                  color: "rgba(0,0,0,.67)",
                }}>
                关闭其它
              </Button>
              <Tabs
                type="editable-card"
                hideAdd
                animated={false}
                activeKey={this.state.activeKey}
                onChange={this.onChange}
                onEdit={this.onEdit}>
                {this.state.panes.map((pane) => {
                  const isMicroApp = typeof pane.content === "object" && pane.content.isMicroApp;
                  const tabMicroAppStyle = {
                    overflow: "auto",
                    display: this.state.activeKey === pane.key ? "block" : "none",
                    background: "white",
                    borderRadius: "4px",
                    minHeight: "400px",
                    height: "calc(100vh - 152px)",
                  };
                  const tabStyle = this.state.currMicroAppName
                    ? { display: "none" }
                    : tabMicroAppStyle;
                  if (isMicroApp) {
                    return (
                      <TabPane
                        tab={pane.title}
                        key={pane.key}
                        closable={pane.key === "02" ? false : pane.closeable}>
                        {null}
                      </TabPane>
                    );
                  } else {
                    return (
                      <TabPane
                        tab={pane.title}
                        key={pane.key}
                        closable={pane.closable}
                        contentRef={this.refs.pageContent}>
                        <div style={tabStyle}>{pane.content}</div>
                      </TabPane>
                    );
                  }
                })}
              </Tabs>
              {/* 子应用容器 */}
              <ScLayoutMicroAppContainer
                loading={this.state.appLoading}
                currMicroAppName={this.state.currMicroAppName}
                frames={this.Frame}
              />
            </div>

            {/* <div className="sc-content-footer"></div> */}
          </Content>
          {/* <Footer
            // className="sc-oms-footer"
            style={{
              paddingLeft: this.state.collapsed ? "100px" : "206px",
              height: "40px",
              lineHeight: "40px",
            }}>
            COPYRIGHT &copy;2018 {this.internationalization.company} All rights reserved.{" "}
            {this.props.intl.locale === "zh" ? (
              <a
                onClick={() => {
                  window.open("https://beian.miit.gov.cn/");
                }}>
                苏ICP备14056214号-3
              </a>
            ) : null}
            &nbsp;&nbsp;&nbsp;&nbsp; {this.internationalization.msg2}：
            {process.env.REACT_APP_VERSION} &nbsp;&nbsp;&nbsp;&nbsp;
            {this.internationalization.webc}{" "}
            <span title={this.internationalization.web1}>
              <img style={{ width: "24px", height: "24px" }} src={chrome} alt="" />{" "}
            </span>
          </Footer> */}
        </Layout>
      </Layout>
    );
  }
}

export default injectIntl(ScLayout);

/**
 * react v16.3
 * 组件懒加载 hack  lazy && suspense
 */
// const lazyLoadComponent = (importComponent, childProps) => {
//   /**
//    * 注意： redux注入，任意状态的变更会导致整个页面渲染，继而导致无限调用此函数 -> 更新tab页面 -> redux状态变更 -> xxx, 会出现死循环
//    *
//    * 记录每个tab页组件，使之能够被diff捕获，避免页面组件无效更新
//    */
//   class LazyLoadComponent extends React.PureComponent {
//     constructor() {
//       super();
//       this.state = {
//         component: null,
//       };
//     }

//     async componentDidMount() {
//       const { default: component } = await importComponent();
//       this.setState({
//         component,
//       });
//     }

//     render() {
//       const C = this.state.component;
//       return C ? (
//         <div style={{ minHeight: "calc(100vh - 250px)" }}>
//           <C {...this.props} {...childProps} />
//         </div>
//       ) : null;
//     }
//   }

//   return LazyLoadComponent;
// };



// WEBPACK FOOTER //
// ./src/AntD/components/layout/scLayoutTab.js